import { Grid, Tooltip } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { getCategories, getReports } from '../../../redux/reporting/actions';
import CustomButton from '../../layout/customButton/CustomButton';
import SearchBox from '../../searchBox/SearchBox';
import styles from './ReportingHeader.module.scss';
import * as BUCKET_NAME from '../../../constants/storageBucket';
import * as PROJECT_CODE from '../../../constants/projectCode';
import BackButton from './BackButton';
import { saveDashboardSpec } from '../../../api/Reporting/saveDashboardSpec.api';
import useIcons from '../../../hooks/use-icon';
import { setAlert } from '../../../redux/alerts/action';

const ReportingHeader = ({
	cognosApi,
	getCategories,
	getReports,
	setDashboardSpec,
	dashboardAPI,
	reportUniqueName,
	reportTitle,
	reportDbIndex,
	handleSearch,
	setAlert,
}) => {
	const handleBack = () => {
		try {
			cognosApi.close();

			console.log('Api closed successfully...');
		} catch (error) {
			throw error;
		}
		window.location.reload();
	};

	const getDashboardSpec = async () => {
		try {
			const spec = await dashboardAPI.getSpec();

			console.log('This is the spec', JSON.stringify(spec));
			setDashboardSpec(spec);

			saveDashboardSpec(reportDbIndex, spec);

			setAlert('success', 'Dashboard successfully saved.');
		} catch (error) {
			throw error;
		}
	};
	const downloadCsv = async () => {
		var defaultLink = 'https://storage.googleapis.com';

		var constructedLink = `${defaultLink}/${BUCKET_NAME.storageBucket}.appspot.com/${PROJECT_CODE.projectCode}/reports/${reportUniqueName}.csv`;
		window.open(constructedLink);
		setAlert('success', 'CSV downloaded successfully');
	};

	const refreshPage = () => {
		window.location.reload();
	};

	const RefreshIcon = useIcons('IoMdRefresh');
	return (
		<>
			<Grid
				className={styles.reporting_header}
				container
				justifyContent='space-between'
			>
				<Grid item className={styles.title_wrapper}>
					<div className={styles.header_title}>
						{cognosApi ? reportTitle : 'Reporting'}
					</div>
				</Grid>
				<Grid item>
					<SearchBox
						placeholder={'Search Reports'}
						handleChange={handleSearch}
					/>
				</Grid>
			</Grid>
			<hr className={styles.separator} />
			{cognosApi && (
				<div className={styles.header_actions}>
					<BackButton
						icon={'MdKeyboardArrowLeft'}
						onClick={handleBack}
					/>
					<div className={styles.side_actions}>
						<div
							className={styles.side_action_item}
							onClick={refreshPage}
						>
							<Tooltip title='Refresh'>
								<RefreshIcon />
							</Tooltip>
						</div>
						<div className={styles.side_action_item}>
							<CustomButton onClick={downloadCsv} hovered>
								Download CSV
							</CustomButton>
						</div>
						{/* <div className={styles.side_action_item}>
							<CustomButton onClick={getDashboardSpec} hovered>
								Save Dashboard
							</CustomButton>
						</div> */}
					</div>
				</div>
			)}
		</>
	);
};

export default connect(null, { getReports, getCategories, setAlert })(
	ReportingHeader
);
